import I18n from 'I18n';
import { SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { HUBSPOT_CREDITS_CARD } from '../../../constants/tracking/TrackingSources';
import { usePurchaseMotionsForHubSpotCreditsTile } from '../../../features/purchaseMotions/hooks/usePurchaseMotionsForHubSpotCreditsTile';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { useAppSelector } from '../../../reducers';
import { productSelector } from '../../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../../utils/urls/appQueryParamUtils';
import { CreditsFeatures } from '../features-display/CreditsFeatures';
import { MerchCardLayoutUIGridRowStart } from '../merch-card-layout-ui/MerchCardLayoutUIGridRowStart';
import HubSpotCreditsTileCTAs from './HubSpotCreditsTileCTAs';
import HubSpotCreditsTilePrice from './HubSpotCreditsTilePrice';
import { UnlockHubSpotCreditsInfo } from './UnlockHubSpotCreditsInfo';
import { SIZE_TO_QUANTITY_MAP } from './constants';
import { configureHubSpotCreditsProductConfigurations } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
const HubSpotCreditsTile = ({
  screen,
  size,
  location,
  hubSpotCreditsFeature,
  productApiName,
  unlockHubSpotCreditsSkuIds,
  shouldShowUnlockHubSpotCreditsInfo,
  isCollapsible = false
}) => {
  const TITLE_COPY = {
    CUSTOMER_AGENT: {
      SMALL: {
        title: I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.SMALL.title'),
        subtitle: I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.SMALL.subtitle')
      },
      MEDIUM: {
        title: I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.MEDIUM.title'),
        subtitle: I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.MEDIUM.subtitle')
      },
      LARGE: {
        title: I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.LARGE.title'),
        subtitle: I18n.text('merchCards.hubSpotCredits.CUSTOMER_AGENT.LARGE.subtitle')
      }
    },
    BREEZE: {
      SMALL: {
        title: I18n.text('merchCards.hubSpotCredits.BREEZE.SMALL.title'),
        subtitle: I18n.text('merchCards.hubSpotCredits.BREEZE.SMALL.subtitle')
      },
      MEDIUM: {
        title: I18n.text('merchCards.hubSpotCredits.BREEZE.MEDIUM.title'),
        subtitle: I18n.text('merchCards.hubSpotCredits.BREEZE.MEDIUM.subtitle')
      },
      LARGE: {
        title: I18n.text('merchCards.hubSpotCredits.BREEZE.LARGE.title'),
        subtitle: I18n.text('merchCards.hubSpotCredits.BREEZE.LARGE.subtitle')
      }
    }
  };
  const isAppReady = useGlobalLoading();
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const creditsProduct = useAppSelector(state => {
    if (!isAppReady) {
      return null;
    }
    return productSelector(state, {
      apiName: productApiName
    });
  });
  const creditsSkuId = creditsProduct === null || creditsProduct === void 0 ? void 0 : creditsProduct.currentSkuId;
  const {
    purchaseProductConfigurations,
    unlockHubSpotCreditsProductConfigurations
  } = configureHubSpotCreditsProductConfigurations({
    creditsSkuId: creditsSkuId !== null && creditsSkuId !== void 0 ? creditsSkuId : null,
    size,
    unlockHubSpotCreditsSkuIds
  });
  const purchaseMotions = usePurchaseMotionsForHubSpotCreditsTile({
    unlockHubSpotCreditsProductConfigurations,
    creditsLocation: location
  });
  if (!creditsProduct || !creditsSkuId) {
    return null;
  }
  const productIdentifier = `${productApiName}-${size}`;
  return /*#__PURE__*/_jsx(MerchCardLayoutUIGridRowStart, {
    "data-test-id": `${productIdentifier}-merch-card`,
    "data-selenium-id": `${productIdentifier}-merch-card`,
    columnStart: 0,
    Title: /*#__PURE__*/_jsx(SectionTitle, {
      children: TITLE_COPY[hubSpotCreditsFeature][size].title
    }),
    Subheading: /*#__PURE__*/_jsx(SectionSubTitle, {
      children: TITLE_COPY[hubSpotCreditsFeature][size].subtitle
    }),
    Pricing: /*#__PURE__*/_jsx(HubSpotCreditsTilePrice, {
      quantity: SIZE_TO_QUANTITY_MAP[size],
      seleniumId: productIdentifier,
      term: queryParamTerm
    }),
    Subtext: shouldShowUnlockHubSpotCreditsInfo ? /*#__PURE__*/_jsx(UnlockHubSpotCreditsInfo, {
      seleniumId: `${productIdentifier}-unlock-customer-agent`,
      unlockHubSpotCreditsProductConfigurations: unlockHubSpotCreditsProductConfigurations,
      hubSpotCreditsProduct: hubSpotCreditsFeature,
      unlockHubSpotCreditsSkuId: unlockHubSpotCreditsSkuIds === null || unlockHubSpotCreditsSkuIds === void 0 ? void 0 : unlockHubSpotCreditsSkuIds[0]
    }) : null,
    CTAs: /*#__PURE__*/_jsx(HubSpotCreditsTileCTAs, {
      screen: screen,
      purchaseMotions: purchaseMotions,
      productConfigurations: purchaseProductConfigurations,
      location: location,
      trackingSource: `${size}-${HUBSPOT_CREDITS_CARD}`,
      productIdentifier: productIdentifier
    }),
    Features: /*#__PURE__*/_jsx(CreditsFeatures, {
      hubSpotCreditsFeature: hubSpotCreditsFeature,
      size: size,
      isCollapsible: isCollapsible,
      loading: !isAppReady
    })
  });
};
export default HubSpotCreditsTile;